import { NavLink } from 'react-router-dom';
import { item } from '../../utils/animations';
import styles from './FooterSubSections.module.css';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const FooterInfo = () => {
    const { t } = useTranslation();
    const handlePrivacyPolicy = () => {
        window.open(
            "https://www.privacypolicies.com/live/180fe99b-b335-4150-b681-d91e7163b3d7",
            "_blank"
        )
    }

    return (
        <motion.div
            className={styles.wrapper}
            variants={item}
        >
            <h1 className={styles.title}>
                {t('footer.info.info')}
            </h1>
            <div className={styles.body}>
                {/*<NavLink
                    to="/about"
                    className={styles.text}
                >
                    {t('footer.info.about')}
                </NavLink>*/}
                <NavLink
                    to="/contact"
                    className={styles.text}
                >
                    {t('footer.info.contact')}
                </NavLink>
                <div
                    className={styles.text}
                    onClick={handlePrivacyPolicy}
                >
                    {t('footer.info.privacyPolicy')}
                </div>
            </div>
        </motion.div>
    )
}